export interface Track {
  id: string;
  name: string;
  title?: string;
}

/**
 * Returns the track object (with id, name, and title if present) for a given track_id.
 * @param track_id The id of the track to find
 * @param tracks The array of tracks (from tracks JSON)
 * @returns The matching track object, or undefined if not found
 */
export function getTrackById(track_id: string, tracks: Track[]): Track | undefined {
  return tracks.find(track => track.id === track_id);
}
